exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-container[data-v-2886a12c]{margin-top:-40px}.help-text[data-v-2886a12c]{padding-top:10px;padding-bottom:10px;margin-left:-15px;font-style:italic;font-weight:bolder;font-size:14px;font-family:artifaktElementRegular}.sync-btn[data-v-2886a12c]{border:none;background:transparent;color:#5f60ff;outline:none;margin-left:5px;font-size:14px}.sync-btn[data-v-2886a12c]:hover{color:#0056b3}", ""]);

// exports
